/**
 Add more tester fns for SMP in this file as needed
 */

import {
  doSSNsMatch,
  getTierMinimum,
  minimumSummitIClassInvestAmount,
  tierTypes
} from './summit.utils';
import { StateTester } from '../../core/match';
import { accountTypes, filterExistingInvestmentsFromNew } from './utils';

const NEXT_TIER_PERCENT = 10;

export const isWithinNextTierRange = (
  nextTier: number,
  amountToNextTier: number
): boolean => {
  const nextTierMinimum = getTierMinimum(nextTier);
  const nextTierRange = (NEXT_TIER_PERCENT / 100) * nextTierMinimum;
  return amountToNextTier <= nextTierRange;
};

export const isPersonalAssetTier = (tierID = 0): boolean =>
  tierID === tierTypes.PERSONAL_SERVICE ||
  tierID === tierTypes.ENHANCED_PERSONAL_SERVICE;

export const meetsSummitIClassEligibility = (
  fund: any,
  summitTierID: number
): boolean =>
  isPersonalAssetTier(summitTierID) &&
  fund.iClass === false &&
  fund.correspondingFund?.iClass === true &&
  fund.amount >= minimumSummitIClassInvestAmount;

export const meetsTrustRequirements = (
  accountType,
  trust,
  trustee
): boolean => {
  if (accountType === accountTypes.TRUST) {
    return doSSNsMatch(trust, trustee);
  }
  return true;
};

const hasEligibleFunds = (funds: any[], summitTierID = 0): boolean =>
  funds && funds.some(fund => meetsSummitIClassEligibility(fund, summitTierID));

// TODO [2021-12-01]: fix complexity
/* eslint-disable complexity */
export const meetsSummitRewardsTierForIClass: StateTester = (_, nextState) => {
  const { accountType, app, chosenInvestments = [], summitData } =
    nextState?.store || {};

  const filteredNewInvestments = filterExistingInvestmentsFromNew(
    app?.existingAccounts,
    chosenInvestments
  );

  return (
    !!filteredNewInvestments?.length &&
    hasEligibleFunds(filteredNewInvestments, summitData?.assetTierID) &&
    meetsTrustRequirements(accountType, app?.trust, app?.trustee)
  );
};
/* eslint-enable complexity */

export const meetsSummitIClassMin = (
  iClassReward: boolean,
  amount: number
): boolean => iClassReward && amount >= minimumSummitIClassInvestAmount;
